'use strict';

(function () {
    'use strict';

    angular.module('damages.informManager', ['ui.router', 'common']);
})();